$(function(){
	$('#frmChangePassword').each(function(){
		var pass1 = $('input[name=password]'),
			pass2 = $('input[name=confirmpassword]'),
			submit = $('input[type=submit');

		pass1.attr('autocomplete','off');
		pass2.attr('autocomplete','off');

		pass2.keyup(function(){
			if(pass1.val() === pass2.val() && pass1.val().length > 2){
				submit.attr('isdisabled',false).css({
					'background':'#000',
					'cursor':'unset'
				});
			} else{
				submit.attr('isdisabled',true).css({
					'background':'#eaeaea',
					'cursor':'not-allowed'
				});
			}
		}).keyup();

		submit.on('click',function(event){
			if($(this).attr('isdisabled') == 'true'){
				event.preventDefault();
				alert('Passwords do not match. Please correctly confirm your new password to continue.');
				pass1.val('');
				pass2.val('');
			}
		})
	});
})